import image from "../../assets/pagebanner3.jpg";
import kids1 from "../../assets/kid01.jpg";
import kids2 from "../../assets/kid02.jpg";
import kids3 from "../../assets/kid03.jpg";
import kids4 from "../../assets/kid04.jpg";
import kids5 from "../../assets/kid05.jpg";
import kids6 from "../../assets/kid06.jpg";
import kids7 from "../../assets/kid07.jpg";
import kids8 from "../../assets/kid08.jpg";
import kids9 from "../../assets/kid09.jpg";
import kids10 from "../../assets/kid10.jpg";
import kids11 from "../../assets/kid11.jpg";
import kids12 from "../../assets/kid12.jpg";
import kids13 from "../../assets/kid13.jpg";
import kids14 from "../../assets/kid14.jpg";
import kids15 from "../../assets/kid15.jpg";
import kids16 from "../../assets/kid16.jpg";
import kids17 from "../../assets/kid17.jpg";
import kids18 from "../../assets/kid18.jpg";
import kids19 from "../../assets/kid19.jpg";
import kids20 from "../../assets/kid20.jpg";
import kids21 from "../../assets/kid21.jpg";
import kids22 from "../../assets/kid22.jpg";
import kids23 from "../../assets/kid23.jpg";
import kids24 from "../../assets/kid24.jpg";

export const KIDS = [
  {
    img: image,
  },
];

export const KIDDATA = [
  {
    id: 13,
    image1: kids1,
    image2: kids2,
    title: "Gran Turismo 7",
    star: 4,
    price: "$22.49",
    newprice: " $25.33",
    quick: "Quick View",
    addto: "Add To Cart",
    new: "New",
    category: "arrival",
    mainCategory: "recommend",
  },
  {
    id: 14,
    image1: kids3,
    image2: kids4,
    title: "GRID Legends",
    star: 5,
    price: "$69.99",
    newprice: "$79.99",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "top",
    mainCategory: "recommend",
  },
  {
    id: 15,
    image1: kids5,
    image2: kids6,
    title: "Hot Wheels Unleashed",
    star: 4,
    price: "$54.79",
    newprice: "$45.36",
    quick: "Quick View",
    addto: "Add To Cart",
    new: "New",
    category: "arrival",
    mainCategory: "recommend",
  },
  {
    id: 16,
    image1: kids7,
    image2: kids8,
    title: "NBA 2K21",
    star: 5,
    price: "$16.85",
    newprice: "$19.00",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "top",
    mainCategory: "recommend",
  },
  {
    id: 17,
    image1: kids9,
    image2: kids10,
    title: "Need for Speed Heat",
    star: 4,
    price: "$13.14",
    newprice: "$23.00",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "trending",
    mainCategory: "recommend",
  },
  {
    id: 18,
    image1: kids11,
    image2: kids12,
    title: "Rocket League",
    star: 4,
    price: "$17.00",
    newprice: "$20.00",
    quick: "Quick View",
    addto: "Add To Cart",
    new: "New",
    category: "arrival",
    mainCategory: "recommend",
  },
  {
    id: 19,
    image1: kids13,
    image2: kids14,
    title: "EA SPORT FIFA 22",
    star: 5,
    price: "$13.00",
    newprice: "$15.01",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "top",
    mainCategory: "recommend",
  },
  {
    id: 20,
    image1: kids15,
    image2: kids16,
    title: "Need for Speed: Unbound",
    star: 4,
    price: "$13.00",
    newprice: "$15.01",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "trending",
    mainCategory: "recommend",
  },
  {
    id: 21,
    image1: kids17,
    image2: kids18,
    title: "MLB The Show 21",
    star: 4,
    price: "$16.85",
    newprice: "$19.00",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "trending",
    mainCategory: "recommend",
  },
  {
    id: 22,
    image1: kids19,
    image2: kids20,
    title: "F1 22",
    star: 5,
    price: "$16.85",
    newprice: "$19.00",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "top",
    mainCategory: "recommend",
  },
  {
    id: 23,
    image1: kids21,
    image2: kids22,
    title: "PGA Tour 2K21",
    star: 4,
    price: "$15.20",
    newprice: "$22.20",
    quick: "Quick View",
    addto: "Add To Cart",
    nonew: "removeNew",
    category: "trending",
    mainCategory: "recommend",
  },
  {
    id: 24,
    image1: kids23,
    image2: kids24,
    title: "Trials Rising",
    star: 4,
    price: "$40.00",
    newprice: "$60.00",
    quick: "Quick View",
    addto: "Add To Cart",
    category: "arrival",
    new: "New",
    mainCategory: "recommend",
  },
];
